import ItemsRepository from "./itemsRepository"
import IIIFRepository from "./iiifRepository"


const repositories = {
    items: ItemsRepository,
    iiif: IIIFRepository,
}


export const RepositoryFactory = {
    get: name => repositories[name]
}
